import { useState } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { Box, Container, Typography, makeStyles } from '@material-ui/core';

// layout
import HomeLayout from '/layouts/HomeLayout';

// components
import WysiwygViewer from '/components/shared/TextEditorViewer';
import BackButton from '/components/shared/BackButton';
import PdfViewer from '/components/shared/PdfViewer';

// actions
import { getOnePost, getAllPost } from '/context/actions/post';

// utils
import { getExtension } from 'utils/functions';

// icons
import { Clock as ClockIcon } from 'react-feather';

const useStyles = makeStyles((theme) => ({
    root: {
        // minHeight: '100%',
        marginTop: 20,
        paddingBottom: theme.spacing(3),
    },
}));

const More = ({ post }) => {
    const classes = useStyles();
    const router = useRouter();
    const [size, setSize] = useState({
        height: 0,
        width: 0,
    });

    const handleButtonClick = () => {
        if (router.query.page) router.push('/home');
        else router.back();
    };

    if (!post) {
        return (
            <Container maxWidth="lg" className={classes.root}>
                <Box style={{ marginBottom: 20 }}>
                    <BackButton onClick={handleButtonClick} />
                </Box>
                <Typography>Мэдээлэл олдсонгүй</Typography>
            </Container>
        );
    }

    let ext = null;
    if (post.image) {
        ext = getExtension(post.image);
    }

    return (
        <Container maxWidth="lg" className={classes.root}>
            <Box style={{ marginBottom: 20 }}>
                <BackButton onClick={handleButtonClick} />
            </Box>
            <Box
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 15,
                }}
            >
                <Box style={{ display: 'flex', flexDirection: 'row' }}>
                    <ClockIcon style={{ marginRight: 8 }} size={18} />
                    <Typography variant="body1">{post.own_date.split('T')[0]}</Typography>
                </Box>
            </Box>
            <Typography variant="h1" style={{ marginBottom: 20 }}>
                {post.title}
            </Typography>
            {ext !== 'pdf' && ext != null && (
                <Box
                    style={{
                        width: '100%',
                        marginBottom: 18,
                    }}
                >
                    <Image
                        src={post.image}
                        alt="news"
                        layout="responsive"
                        width={size.width}
                        height={size.height}
                        onLoadingComplete={(imageDimension) =>
                            setSize({
                                height: imageDimension.naturalHeight,
                                width: imageDimension.naturalWidth,
                            })
                        }
                        objectPosition="top right"
                    />
                </Box>
            )}
            <Typography variant="h4" style={{ marginBottom: 20 }}>
                {post.short_content}
            </Typography>
            <Box style={{ marginTop: 20, marginBottom: 20 }}>
                <WysiwygViewer data={post.body} />
            </Box>
            {ext === 'pdf' && <PdfViewer url={post.image} />}
        </Container>
    );
};

export async function getServerSideProps(context) {
    let post = null;
    if (context.query.page) {
        post = await getAllPost('?menu_id=' + context.params.id);
        if (post.list) post = post.list[0];
    } else {
        post = await getOnePost(context.params.id);
    }

    if (!post) {
        return {
            props: { post: null },
        };
    }

    return {
        props: { post, id: context.params.id }, // will be passed to the page component as props
    };
}

More.Layout = HomeLayout;

export default More;
